import * as cx from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import * as Styles from './ProductName.scss';

interface IOwnProps {
  onClick: {
    uri?: string;
    action?: (event: React.SyntheticEvent<HTMLElement>) => void;
  };
  name: string;
  size?: 'big';
  isClickable?: boolean;
}

const ProductName: React.SFC<IOwnProps> = ({ onClick, name, size, isClickable }) => {
  const { uri, action } = onClick;

  const productNameClassNames = cx({
    [Styles.name]: true,
    [Styles.big]: size && size === 'big',
  });

  const linkClassNames = cx({
    [Styles.link]: true,
    [Styles.noClickable]: !isClickable,
  });

  return (
    <Fragment>
      {uri && (
        <a className={linkClassNames} href={uri}>
          <span className={productNameClassNames}>{name}</span>
        </a>
      )}
      {action && (
        <div className={linkClassNames} onClick={onClick.action}>
          <span className={productNameClassNames}>{name}</span>
        </div>
      )}
    </Fragment>
  );
};

export default ProductName;
